import { SelectorFn } from "./selectorFn";
import { BaseMessage, Message } from "@me8eon/messages";

/** Selects this if the keyword is present in the last user message */
export type KeywordSelector = {
    type: "keywords";
    keywords: string[];
    select: string;
    description?: string;
};

function find(keywords: string[], messages: Message[]): boolean {
    if (!messages.length) return false;

    const lastMessage = messages[messages.length - 1];
    if (!lastMessage?.content) return false;

    const lowerKeywords = keywords.map(k => k.toLowerCase());
    const words = lastMessage.content
        .split(/\s+/)
        .filter(Boolean)
        .map(w => w.toLowerCase());

    return words.some(word => lowerKeywords.includes(word));
}

export const keywordSelector: SelectorFn<any, KeywordSelector> = {
    isDefinedAt: (selector, _context, messages) => find(selector.keywords, messages),

    execute: async (selector, context, messages) => {
        if (find(selector.keywords, messages)) {
            return {
                value: {
                    context,
                    selected: selector.select,
                    messages,
                },
                log: {
                    whatHappened: "selector.keyword.matched",
                    params: {
                        keywordMatched: selector.select,
                    },
                },
            };
        }

        return {
            errors: [
                `No keyword found in the last message. Expected one of: ${selector.keywords.join(", ")}`,
            ],
            log: {
                whatHappened: "selector.keyword.execute",
                severity: "error",
            },
        };
    },
};
